export default "__VITE_ASSET__D5jZf9Vb__"